var isDesktop = function () {
    return window.innerWidth >= ICF.Variables.Breakpoints.Desktop;
};

module.exports = isDesktop;